import router from '../router';
import store from '../store';
// channel 和 bizId 的值为 MEDIC_SALE
const channel = 'MEDIC_SALE';

// 这里处理智云医道向商城的跳转
export default {
  data: function () {
    return {
      rxId: '',
      turnMallBasePath: ''
    };
  },

  created() {
    // 这个页面会有一个rxId
    this.rxId = this.$route.query.id || '';
    // 这里通过部署的一套新的商城代码到dia-solution.com，实现主域名地址不变，zyyd -> static
    const baseUrl = window.location.origin.replace('zyyd', 'static');
    // 这里的后半段应该不变吧
    this.turnMallBasePath = `${baseUrl}/f2e/patient-mall`;
  },

  methods: {
    // 这里的填写订单需要跳转到mall的页面prescribed
    // 通过处方id来下单，从智云医道跳转到智云商城
    jumpToMallPrescribed(bol) {
      if (bol) {
        this.$router.push({
          name: 'PreOrder',
          query: {
            rxId: this.rxId,
            rxType: this.recipeData.prescriptionType
          }
        });
      } else {
        const jumpUrl = `${this.turnMallBasePath}/#/prescribed/${this.rxId}?channel=${channel}&rxId=${this.rxId}`;
        window.location.href = jumpUrl;
      }
    },
    // 跳转到商城的订单列表页面
    jumpToMallOrderList() {
      router.push({
        name: 'orderList',
        params: {
          active: '0'
        }
      });
    },
    // 跳转到商城的订单列表页面
    jumpToMallOrderDetail(orderId, isDrug) {
      // const str = isDrug == 0 ? `&hasRecommendOrder=1` : '';
      // const jumpUrl = `${this.turnMallBasePath}/#/order-detail/${orderId}?channel=${channel}${str}`;
      // if (isDrug == 0) {
      //   window.location.replace(jumpUrl);
      //   return;
      // }
      // window.location.href = jumpUrl;
      router.push({
        name: 'orderDetail',
        params: {
          id: orderId
        },
        query: {
          orderId,
          hasRecommendOrder: isDrug == 0 ? 1 : ''
        }
      });
    },
    // 跳转商城的地址列表
    jumpToMallAddressList() {
      router.push({
        name: 'AddressList',
        query: {
          from: 'zyyd-user-center'
        }
      });
    },

    async requestPreOrderAndJumpToPlaceOrder(params, otherQuery = { doctorId: '', rxId: '' }) {
      try {
        const preOrderParams = {
          ...params
        };
        preOrderParams.orders = params.orders.map((item) => {
          return {
            deliveryWay: item.deliveryWay || params.deliveryWay || 1,
            itemId: item.itemId,
            itemNum: item.amount || item.itemNum || 0,
            supplierId: item.supplierId || null
          };
        });

        store.commit('order/setHasMoreCoupons', false); // 防止之前缓存了是否有优惠券
        store.commit('order/setCouponInfo', {}); // 防止之前缓存了优惠券
        store.commit('order/setPreOrderParams', preOrderParams);

        router.push({
          name: 'PlaceOrder',
          query: {
            ...otherQuery
          }
        });
      } catch (e) {
        // do nothing
      }
    },

    async saveDataAndToPreOrder(otherQuery) {
      router.push({
        name: 'PreOrder',
        query: {
          ...otherQuery
        }
      });
    }
  }
};
